import { Box, Separator, Stack, Text } from "@chakra-ui/react";

const VirtualTour = ({ dataDevelopment }) => {
    return (
        <Stack>
            {dataDevelopment?.media_props?.virtual_url && (
                <Box bg="white" rounded="md">
                    <Text fontWeight={700} fontSize="md" mt="3vh" mb={4}>
                        Recorrido Virtual
                    </Text>
                    <Box borderRadius="md" overflow="hidden" mb="5vh">
                        <iframe
                            src={dataDevelopment?.media_props?.virtual_url}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; xr-spatial-tracking"
                            allowFullScreen
                            width="100%"
                            height="400"
                        />
                    </Box>
                    <Separator borderColor="#B1B1B1" />
                </Box>
            )}
        </Stack>
    );
};

export default VirtualTour;
